<template>
  <div class="swipey-container">
    <div class="columns is-mobile is-gapless swipey-container-top">
        <div class="column is-one-third">
          <span class="icon" style="color: red">
            <i class="fas fa-angle-double-right"/>
          </span>
        </div>
        <div class="column is-one-third">
          <NoloStats/>
        </div>
        <div class="column is-one-third">
          <NoloCalls/>
        </div>
    </div>
    <div
      v-on:mousedown="startSwipe" v-on:touchstart="startSwipe"
      v-on:mousemove="doSwipe" v-on:touchmove="doSwipe"
      class="swipey-container-bottom"/>
  </div>
</template>
<script>
  import JQuery from 'jquery'
  import NoloStats from './NoloStats'
  import NoloCalls from './NoloCalls'
  let $ = JQuery

  export default {
    name: 'SwipeyContainer',
    components: { NoloStats, NoloCalls },
    data() {
      return {
        swiping: false,
        snappingToPosition: false,
        lastX: 0,
      }
    },
    methods: {
      getXPos(event) {
        if(event.type == "mousemove") {
          return event.screenX;
        } else {
          return event.touches[0].screenX;
        }
      },
      snapToScreen(screenNum) {
        let screenWidth = $(window).width();
        $(".swipey-container").css("left", screenNum * (-screenWidth));
      },
      startSwipe(event) {
        this.swiping = true;
        this.lastX = event.screenX;
      },
      stopSwipe() {
        this.swiping = false;
        this.snappingToPosition = true;
        let screenWidth = $(window).width();
        let centerPos =
          -1*$(".swipey-container").position().left + screenWidth/2;

        // Select correct screen based on centerPos.
        if(centerPos < screenWidth) this.snapToScreen(0);
        else if(centerPos < 2*screenWidth) this.snapToScreen(1);
        else this.snapToScreen(2);

        this.snappingToPosition = false;
      },
      doSwipe(event) {
        if(this.swiping && !this.snappingToPosition) {
          let xPos = this.getXPos(event);



          let delta = xPos - this.lastX;
          this.lastX = xPos;

          let swipeyElem = $(".swipey-container");
          let position = swipeyElem.position();
          swipeyElem.css("left", position.left + delta);
        }
      }
    },
    mounted() {
      // Setup default swipey box position.
      let swipeyElem = $(".swipey-container");
      let position = swipeyElem.position();
      let screenHeight = $(window).height();
      let screenWidth = $(window).width();
      swipeyElem.css("height", screenHeight - position.top);
      swipeyElem.css("left", -screenWidth);

      // Listener for when a swipe finishes.
      window.addEventListener('mouseup', this.stopSwipe);
      window.addEventListener('touchend', this.stopSwipe);
    }
  }
</script>
<style scoped>
  .swipey-container {
    position: fixed;
    width: 300%;
  }
  .swipey-container-top {
    height: 80%;
    margin-bottom: 0 !important;
  }
  .swipey-container-bottom {
    height: 20%;
  }
</style>
